import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

@Injectable()
export class AnnexPreviewService {
  private previewUpdateSubject = new ReplaySubject<Blob>(1);
  
  previewUpdate$ = this.previewUpdateSubject.asObservable();

  updatePreview(pdfBlob: Blob): void {
    this.previewUpdateSubject.next(pdfBlob);
  }
}